import { ApprovalConsiderationAnnounceSevenContainer } from '../../../containers/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceSevenContainer';

export function ApprovalConsiderationAnnounceSevenPage() {
    return (
        <ApprovalConsiderationAnnounceSevenContainer />
    )
}